import { Injectable } from '@angular/core';
import { Directory, Encoding, Filesystem } from '@capacitor/filesystem';

@Injectable({
  providedIn: 'root'
})
export class LecteurStorageService {
  private readonly filename = 'deviceIdSCE.txt';

  async getDeviceId(): Promise<string | null> {
    try {
      const result = await Filesystem.readFile({
        path: this.filename,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      });
      return result.data as string;
    } catch (e) {
      return null;
    }
  }

  async setDeviceId(value: string): Promise<void> {
    try {
      await Filesystem.writeFile({
        path: this.filename,
        data: value,
        directory: Directory.Data,
        encoding: Encoding.UTF8,
      });
    } catch (e) {
      throw e;
    }
  }

  async removeDeviceId(): Promise<void> {
    try {
      await Filesystem.deleteFile({
        path: this.filename,
        directory: Directory.Data
      });
    } catch (e) {
      return null;
    }
  }
}
